import React, {useEffect, useState} from "react";
import {DatasetsApi} from "api/DatasetsApi";
import {AutoComplete, AutoCompleteChangeParams, AutoCompleteCompleteMethodParams} from "primereact/autocomplete";
import {DropdownItem} from "utils/general-models";
import ChartInDialogButton from 'components/basic/chart-in-dialog-button/ChartInDialogButton';
import CopyTextWithButton from 'components/basic/copy-text-with-button/CopyTextWithButton';

interface IDatasetMultiSelectProps {
    // Dataset identifier
    id?: string;
    value?: string[] | null;
    onChange: (e: string[]) => void;
    style?: React.CSSProperties;
    disabled?: boolean;
}

export function DatasetMultiSelect(props: IDatasetMultiSelectProps) {
    const [selectedDatasets, setSelectedDatasets] = useState<DropdownItem<string>[] | null>(null);
    const [filteredDatasets, setFilteredDatasets] = useState<DropdownItem<string>[]>([]);

    const [error, setError] = useState(false);

    useEffect(() => {
        if(props.value && props.value.length > 0){
            DatasetsApi.queryDatasets(null, 0, props.value).then((r) => {
                if(!r.error && r.data){
                    const selections = r.data.map((it) => ({ value: it.identifier, label: it.toString() } as DropdownItem<string>))
                    setSelectedDatasets(selections);
                }
            });
        }
    }, [props.value])

    const searchDatasets = (e: AutoCompleteCompleteMethodParams) => {
        DatasetsApi.queryDatasets(e.query, 100).then((r) => {
            if(!r.error && r.data){
                const selectedDatasetIdentifiers = selectedDatasets?.map(dataset => dataset.value) || [];
                const selections = r.data
                    .filter(it => !selectedDatasetIdentifiers.includes(it.identifier as string))
                    .map((it) => ({ value: it.identifier, label: it.toString() } as DropdownItem<string>));
                setFilteredDatasets(selections);
            } else {
                setError(true);
            }
        });
    }

    const onChange = (e: AutoCompleteChangeParams) => {
        setSelectedDatasets(e.value);

        if(typeof e.value === "string") return; // Ignore string auto complete dumb input

        props.onChange(e.value?.map((item:DropdownItem<string>) => item.value) || null);
    }

    const chipTemplate = (item: DropdownItem<string>) => {
		return (
			<div className='flex nowrap gap-1 align-items-baseline mr-2'>
				<span>{item.label}</span>
				<CopyTextWithButton text='' copyableText={item.value} />
				<ChartInDialogButton identifier={item.value} header='Dataset' />
			</div>
		);
	};

    return (
			<>
				<AutoComplete
					placeholder='Type for search datasets...'
					multiple={true}
					value={selectedDatasets}
					suggestions={filteredDatasets}
					onChange={onChange}
					completeMethod={searchDatasets}
					minLength={3}
					field='label'
					style={{ width: '100%', ...props.style }}
					disabled={props.disabled}
					selectedItemTemplate={chipTemplate}
				/>
			</>
		);
}